import {BaseMetadataModel} from "../../../../infrastructure/models/base-metadata-model";

export class SocialMetadataModel extends BaseMetadataModel {
  get alt(): String {
    const title = this.model.alt;

    return title;
  }

  get title(): String {
    const title = this.model.title;

    return title;
  }
}
